import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../stores/auth.store';
import { UnableToSendPaymentRequestModalComponent } from '../components/modals/unable-to-send-payment-request-modal/unable-to-send-payment-request-modal.component';
import { ModalsService } from '@app/services/modals.service';
import { firstValueFrom } from 'rxjs';

export const isNotAccessRestrictedBillingGuard: CanActivateFn = async (route) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const modalsService = inject(ModalsService);

  if (!authStore.profile()) {
    await authStore.asyncCurrentUser();
  }

  if (authStore.isAccessRestrictedBilling()) {
    router.navigate(['/overview']).then(() => {
      modalsService.openModal(UnableToSendPaymentRequestModalComponent);
    });
    return false;
  } else {
    return true;
  }
};
